import { GetRepayCodeHistoryListReq } from "@/pbjs/xcommon/ticket_pb";
import { setCommon, setPage, handleResponse, errorMsg } from "@/utils/request";
import { ticketClient } from "@/api/ticketClient";

interface ITicketLogReq {
  pageIndex: number;
  pageSize: number;
  orderId: string;
}
export function getRepayCodeHistory(arg: ITicketLogReq) {
  return new Promise((resolve, reject) => {
    (async () => {
      let request = new GetRepayCodeHistoryListReq();
      request.setCommonin(setCommon());
      request.setPagein(setPage(arg.pageIndex, arg.pageSize));
      request.setOrderid(arg.orderId);
      await ticketClient.getRepayCodeHistoryList(
        request,
        {},
        (err: any, response: any) => {
          if (response) {
            const res: any = response.toObject();
            resolve(res);
          }
          if (err) {
            reject(err);
          }
        }
      );
    })();
  })
    .then((response: any) => {
      handleResponse(response, null);
      return response;
    })
    .catch((err: any) => {
      errorMsg(err);
    });
}
